import * as React from "react";
import MassConfigPremisesComponentsQuery from "../../components/Forms/MassConfigPremisesComponents/FlowForm/FlowForm";

export default function MassConfig() {
  return <MassConfigPremisesComponentsQuery />;
}
